import { HStack, Text, Switch, Spinner, Flex } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isFailed,
  isInit,
  isLoading,
} from "../../../../common/helper/commonHelper";
import ITitle from "../../../../components/ITitle";
import {
  getUnsubscribeStatus,
  resetUnsubscribeStatus,
  selectPerson,
  toggleUnsubscribeStatus,
} from "../personDbSlice";

export default function UnsubscribeToggle({ personId }: { personId: string }) {
  const dispatch = useDispatch();
  const { unsubscribeStatus } = useSelector(selectPerson);
  const [subscribed, setSubscribed] = useState(!unsubscribeStatus.unsubscribed);

  useEffect(() => {
    setSubscribed(!unsubscribeStatus.unsubscribed);
  }, [unsubscribeStatus.unsubscribed]);

  useEffect(() => {
    if (isFailed(unsubscribeStatus.updating)) {
      setSubscribed(!unsubscribeStatus.unsubscribed);
    }
  }, [unsubscribeStatus.unsubscribed, unsubscribeStatus.updating]);

  function toggleStatus(status: boolean) {
    if (subscribed !== status) {
      setSubscribed(status);
      dispatch(toggleUnsubscribeStatus(personId));
    }
  }

  useEffect(() => {
    if (personId && isInit(unsubscribeStatus.fetching)) {
      dispatch(getUnsubscribeStatus(personId));
    }
  }, [dispatch, personId, unsubscribeStatus.fetching]);

  useEffect(() => {
    return () => {
      dispatch(resetUnsubscribeStatus());
    };
  }, [dispatch]);

  return (
    <>
      <HStack bg="blackAlpha.50" py={5} px={8} alignItems="center">
        <ITitle
          color="gray.600"
          fontWeight="medium"
          title="Subscription status"
        />
        {isInit(unsubscribeStatus.fetching) ||
        isLoading(unsubscribeStatus.fetching) ? (
          <Spinner ml="7" />
        ) : (
          <HStack alignItems="center">
            <Switch
              ml="5"
              size="sm"
              isChecked={subscribed}
              onChange={(e) => toggleStatus(e.target.checked)}
            ></Switch>
            {isLoading(unsubscribeStatus.updating) ? (
              <Spinner ml="5" />
            ) : (
              <Text fontSize="14">
                {subscribed ? (
                  <Flex>
                    <Text mr="1" fontWeight="semibold">
                      Subscribed
                    </Text>
                  </Flex>
                ) : (
                  <Flex>
                    <Text mr="1" fontWeight="semibold">
                      Unsubscribed
                    </Text>
                  </Flex>
                )}
              </Text>
            )}
          </HStack>
        )}
      </HStack>
    </>
  );
}
